( function( global, $ ) {
    var $bundle = $('[data-bundle]'),
        $bundleDownload = $('.c-bundle-download'),
        $bundleDownloadAll = $('[data-bundle-download-all]'),
        $filterDropdowns = $('.gr-form__dropdown');

    if($bundle && $bundleDownload) {
        $bundle.on('click', 'input[type=checkbox]', function() {
            $(this).closest('.c-card').toggleClass('is-selected');
    
            if ( $('.c-card.is-selected').length === 0 ) {
                $bundleDownload.find('.c-link').attr('disabled', '');
            } else {
                $bundleDownload.find('.c-link').removeAttr('disabled');
            }
    
            $bundleDownload.find('.c-bundle-download__counter span').attr('data-counter', $('.c-card.is-selected').length);
        });
    }

    if ($bundleDownloadAll) {
        $bundleDownloadAll.on('change', function() {
   
            var items = $bundle.find('input[type=checkbox]');

            if($(this).is(':checked')) {
                items.prop('checked', true);
                items.closest('.c-card').addClass('is-selected');
                $bundleDownload.find('.c-link').removeAttr('disabled');
            } else {
                items.prop('checked', false);
                items.closest('.c-card').removeClass('is-selected');
                $bundleDownload.find('.c-link').attr('disabled', '');
            }

            $bundleDownload.find('.c-bundle-download__counter span').attr('data-counter', $('.c-card.is-selected').length);

        });

        var href = window.location.href;

        if (href.indexOf('cat') !== -1 || href.indexOf('col') !== -1) {
            $bundleDownload.find('.c-link').removeAttr('disabled');
        } else {
            $bundleDownloadAll.attr('disabled', '');
        }
    }

    if ($filterDropdowns) {
        
        // Get all the checkboxes in $filterDropdowns
        var $checkboxes = $filterDropdowns.find('input[type=checkbox]');

        // When a checkboxe if checked, we enable he $bundleDownloadAll button
        $checkboxes.on('change', function() {

            // If at least one checkbox is checked
            if ($checkboxes.is(':checked')) {
                $bundleDownloadAll.removeAttr('disabled');
            } else {
                $bundleDownloadAll.attr('disabled', '');
            }
        });
        
    }

    $('.js-downloadImages').click(function(){
        $(this).closest('form').submit();
    });
}( window.groots, jQuery ));
